<template>
<div id="catalogo_mt">
  <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
  components: {
    "v-power-catalogo": powerCatalogo
  },
  created() {
    if(this.$local_storage.get("id_cliente") > 0)
    this.parametros.columns=this.parametros.columns_cliente;
    this.parametros.options=this.parametros.options_cliente;
    window.getApp.$emit("APP_DRAWER_HIDE");
  },

  data: () => ({
    fab: false,
    parametros: {
      url_actions: "apendices/",
      url_list: "apendices/lista/",
      tabla: 30,
      title: "DESTINOS ADUANEROS",
      columns: ["numero", "clave", "nombre", "clave_pedimento", "porcentaje_retorno", "rfc",
        "actions"
      ],
      columns_cliente: ["numero", "clave", "nombre", "clave_pedimento", "porcentaje_retorno", 
        "actions"
      ],
      options_cliente: {
        filterable: ["numero", "clave", "nombre"],
        sortable: ["numero", "clave", "nombre"],

        headings: {
          numero: "Número",
          clave: "Clave",
          nombre: "Nombre",
          clave_pedimento: "Clave Pedimento",
          porcentaje_retorno: "Porcentaje Retorno",
          actions: "Operaciones"
        }
      },
      options: {
        filterable: ["numero", "clave", "nombre", "rfc"],
        sortable: ["numero", "clave", "nombre", "rfc"],

        headings: {
          numero: "Número",
          clave: "Clave",
          nombre: "Nombre",
          clave_pedimento: "Clave Pedimento",
          porcentaje_retorno: "Porcentaje Retorno",
          rfc: "RFC",
          actions: "Operaciones"
        }
      },
      camposexcel: {
        Numero: "numero",
        Clave: "clave",
        Nombre: "nombre",
        Porcentaje: "porcentaje_retorno",
        ClavePedimento: "clave_pedimento"
      },
      encabezadoLayout: {
        numero: "numero",
        clave: "clave",
        nombre: "nombre",
        clave_pedimento: "clave_pedimento",
        porcentaje_retorno: "porcentaje_retorno"
      },
      camposLayout: [{
        numero: "[Numero del Destino Aduanero]",
        clave: "[Clave del Destino Aduanero]",
        nombre: "[Nombre del Destino Aduanero]",
        clave_pedimento: "[Es Clave de pedimento]",
        porcentaje_retorno: "[Tiene porcentaje de retorno]"
      }],
      model: {
        id: 0,
        numero: "",
        clave: "",
        nombre: "",
        clave_pedimento: 0,
        porcentaje_retorno: 0,
        rfc: ""
      },
      form: {
        numero: {
          requiered: false,
          label: "Número",
          value: "",
          maxlen: 10
        },
        clave: {
          requiered: true,
          label: "Clave",
          value: "",
          maxlen: 50
        },
        nombre: {
          requiered: true,
          label: "Nombre",
          value: "",
          maxlen: 350
        },
        rfc: {
          requiered: false,
          label: "RFC",
          value: "",
          maxlen: 20
        },
        clave_pedimento: {
          required: true,
          label: "¿Es Clave de Pedimento?",
          value: 0,
          tipo: "checkbox"
        },
        porcentaje_retorno: {
          required: true,
          label: "¿Tiene porcentaje de retorno?",
          value: 0,
          tipo: "checkbox"
        }
      },
      breadcrumbs: [{
          text: "Inicio",
          disabled: false,
          to: "/home"
        },
        {
          text: "Utilerías",
          disabled: true,
          to: ""
        },
        {
          text: "Apendices",
          disabled: true,
          to: ""
        }
      ]
    }
  })
};
</script>
<style scoped>
.v-card--material {
  min-height: 750px !important;
}
</style>
<style scoped>
.VueTables>>>thead th {
  white-space: normal !important;
}

.VueTables>>>tbody td {
  white-space: normal !important;
}
</style>
